import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Icon, Pdf, Text } from '../../Atoms';
import { DetailDocument } from '../../Molecules';
export default function TemplateListTypeDocument(props) {
  return (
    <div className="template-container template-send-document template-scroll">
      <div
        className="container-title-send-doc"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <span style={{ display: 'flex' }}>
          <Icon
            icon="SortTop"
            size="20px"
            className="icon-return"
            onClick={props.onReturn}
          />
          <Text text={props.state.type.text} className="title-send-document" />
        </span>
      </div>
      {props.state.step === 1 &&
        (props.state.docList.length == 0 ? (
          <div className="content-template-error-msg">
            <p>{props.state.emptyDocListMsg}</p>
          </div>
        ) : (
          <div className="content-template-type-document">
            <Row>
              {props.state.docList.map((el) => (
                <Col
                  xs={12}
                  md={6}
                  className=""
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <DetailDocument
                    text={el.name}
                    onViewFile={() => props.onOpen(el)}
                    onDownload={() => props.onDowLoad(el)}
                  />
                </Col>
              ))}
            </Row>
          </div>
        ))}
      {props.state.step === 2 && (
        <div className="content-template-document-sended">
          <div className="container-doc-sended-step2"></div>
          <div>
            <Pdf url={props.state.file.url} />
          </div>
          <div
            className="container-btn-downlond-doc"
            style={{ paddingBottom: '50px' }}
          >
            <Button
              text="Télécharger"
              onClick={() => props.onDowLoad(props.state.documentSelected)}
              className="btn-downlond-doc"
            />
          </div>
        </div>
      )}
    </div>
  );
}
